import { TResponse } from '@r1-frontend/do-request/core/types';
import { BaseErrorBody, getErrorMessage } from '@r1-frontend/do-request/error/baseErrorBody';
import { INewsCategoriesResponseDto } from '@r1-frontend/api-domru/content-static/v1/news-categories';

import { TAppThunkDispatch } from '~/src/store';
import { setErrorTags, setTags } from '~/src/store/actionCreators/tags';

export const setTagResponse = (response: TResponse<INewsCategoriesResponseDto[], BaseErrorBody>) => {
    return (dispatch: TAppThunkDispatch): void => {
        if (response.isSuccess) {
            dispatch(setTags({
                fetching: false,
                items: response.payload,
            }));
            return;
        }

        dispatch(setErrorTags({
            fetching: false,
            fetchError: getErrorMessage(response),
        }));
    };
};
